module.exports = {
  title: `EHX.dev`,
  description: `Blog posted about ...`,
  author: `EHX`,
  introduction: `Software Developer, Back-End Engineer`,
  siteUrl: `https://ehx.now.sh/`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `ehdgua01`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: `sjkdh12`, // Your Facebook account
    linkedin: ``, // Your LinkedIn account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'ehdgua01/utterances', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: '',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'ehdgua01', // Add your google analytics tranking ID
}
